import React from 'react';
import config from 'config';
import logger from './logger';
import RouterEvents from './RouterEvents';
import createRoutesModule from './routesModule';
var debug = logger.extend('routesExtension');
var getInitialPropsCount = 1;
export default function routesExtension() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      routes = _ref.routes,
      refreshInterval = _ref.refreshInterval;

  return {
    id: 'routes',
    redux: {
      modules: [createRoutesModule({
        routes: routes
      })]
    },
    server: process.browser ? {} : {
      init: function init() {
        require('./config');
      },
      handler: function handler(_ref2) {
        var handler = _ref2.handler,
            app = _ref2.app,
            server = _ref2.server;

        if (routes) {
          return function getRoutesHandler(req, res) {
            for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
              args[_key - 2] = arguments[_key];
            }

            if (!req.context.isInternalRoute) {
              var routesHandler = routes.getRequestHandler(app);
              return routesHandler.apply(void 0, [req, res].concat(args));
            }

            return handler.apply(void 0, [req, res].concat(args));
          };
        }
      },
      configure: function configure(server) {
        // Import these here so they don't impact the browser bundle size.
        var _require = require('./rewriteMiddleware'),
            rewriteMiddleware = _require["default"];

        var _require2 = require('./staticRedirectMiddleware'),
            staticRedirectMiddleware = _require2["default"];

        var enableRewrites = config.get('server.rewrites.enabled');

        if (enableRewrites) {
          debug('rewriteMiddleware is enabled (server.rewrites.enabled is %o)', enableRewrites);
          server.useTracked('rewriteMiddleware', rewriteMiddleware({
            refreshInterval: refreshInterval
          }));
        } else {
          debug('rewriteMiddleware is disabled (server.rewrites.enabled is %o)', enableRewrites);
        }

        server.useTracked('staticRedirectMiddleware', staticRedirectMiddleware());
      }
    },
    app: {
      getInitialProps: function getInitialProps(_ref3) {
        var Component = _ref3.Component,
            ctx = _ref3.ctx;

        if (process.browser) {
          getInitialPropsCount += 1;
        }

        return {};
      },
      render: function render(props, children) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(RouterEvents, {
          getInitialPropsCount: getInitialPropsCount
        }));
      }
    }
  };
}